export default {
    en: {
        coming_soon: "Coming Soon",
        payment_content: "Payment Details",
        select_payment_method: "Select Payment Method",
        credit_card: "Credit Card",
        kakaopay: "Kakao Pay",
        transaction_id: "Transaction ID",
        payment_date: "Payment Date",
        quantity: "Quantity",
        subtotal: "Subtotal",
        total: "Total",
        card_number: "Card Number",
        expiry_date: "Expiry Date",
        password_2digit: "First 2 digits of Password",
        birth_date_6digit: "Date of Birth (6 digits)",
        phone_number: "Phone Number",
        name: "Name",
        email: "Email",
        register_card: "Pay",
        addon_select_prompt: "Select credits or storage to add",
        confirm_unsubscribe: "Are you sure you want to unsubscribe?",
        please_enter_name: "Name",
        please_enter_email: "Email",
        free_plan_conversion_notice: "You will be automatically switched to the Free plan after {0} days.",

        cancel_plan_success: "Plan cancellation completed.",
        current_plan: "Current Plan",
        credit: "Credits",
        credit_addon: "Credits (Add-on)",
        storage_addon: "Storage (Add-on)",
        storage: "Storage",
        next_billing_date: "Next Billing Date: {0}",
        expired_billing_date: "Expiration Date: {0}",
        payment_scheduled: "Payment Scheduled for {0}",
        change_plan: "Change Plan",
        buy_add_ons: "Buy Add-ons",
        compare_plans: "Compare Plans",

        payment_method: "Payment Method",
        change: "Change",

        payment_history: "Payment History",
        date: "Date",
        item: "Item",
        amount: "Amount",
        status: "Status",
        payment_details: "Details",
        payment_method_col: "Payment Method",

        payment_complete: "Payment Complete",
        download_invoice: "Invoice",

        cancel_plan: "Cancel Plan",
        cancel_subscription_undo: "Undo Subscription Cancellation",
        cancel_subscription_undo_confirm_title: "Undo Subscription Cancellation",
        cancel_subscription_undo_confirm_message: "Are you sure you want to undo the subscription cancellation?",
        cancel_subscription_undo_complete_title: "Cancellation Undone",
        cancel_subscription_undo_complete_message: "Subscription cancellation has been successfully undone.\nYou can continue using your existing benefits.",

        cancel_plan_modal_title: "Cancel Plan",
        cancel_plan_desc_1: "Available until {0}",
        cancel_plan_desc_2: "Dear {0}, even if you cancel your {1} plan subscription now, you can continue to use it until {2}. You will not be charged after that.",

        plan_start_date: "Plan Start: {0}",
        ai_optimization_count: "AI Optimizations",
        uploaded_file_size: "Uploaded File Size",
        avg_optimization_rate: "Avg. Optimization Rate",
        optimization_file_download: "Optimized File Download",

        cancel_reason_title: "What is your reason for cancelling?",
        cancel_plan_warning: "If you cancel your plan, your credits, storage, and download period will reset to the Free plan standards after Jan 9, 2026. Are you sure you want to cancel?",

        do_cancel: "Confirm Cancel",
        keep_plan: "Keep Plan",

        confirm: "Confirm",
        cancel: "Cancel",

        payment_method_change_title: "Change Payment Method",
        payment_method_change_complete: "Payment method change completed.",

        payment_success_title: "Payment Complete",
        payment_success_message_new_plan: "Payment completed successfully.\nStart enjoying your new plan benefits now.",
        payment_success_message_addon: "Payment completed successfully.\nEnjoy your benefits now.",

        use_free: "Use for Free",
        current_plan_badge: "Current Plan",
        contact_us: "Contact Us",

        error_title: "Error",
        error_server: "A server error occurred.",
        error_failed: "Processing failed.",
        valid_until_format: "{0}",

        credit_usage_history: "Credit Usage History",
        usage_context: "Usage Context",
        used_credit: "Used Credit",
        credit_type: "Credit Type",
        subscription_credit: "Subscription",
        addon_credit: "Add-on",

        optimization_run_deduction: "Optimization Run (Deduction)",
        optimization_failure_refund: "Optimization Failure (Refund)",
        optimize_id: "Optimization ID",
    },
    ko: {
        coming_soon: "공개 예정",
        payment_content: "결제 내용",
        select_payment_method: "결제수단 선택",
        credit_card: "신용 카드",
        kakaopay: "카카오 페이",
        transaction_id: "거래 ID",
        payment_date: "결제일",
        quantity: "수량",
        subtotal: "소계",
        total: "합계",
        card_number: "카드번호",
        expiry_date: "유효기간",
        password_2digit: "비밀번호 앞 2자리",
        birth_date_6digit: "생년월일 (6자리)",
        phone_number: "핸드폰 번호",
        name: "이름",
        email: "이메일",
        register_card: "결제하기",
        addon_select_prompt: "추가 구매할 크레딧과 스토리지 중 선택해주세요",
        confirm_unsubscribe: "구독을 해지하시겠습니까?",
        please_enter_name: "이름",
        please_enter_email: "이메일",
        free_plan_conversion_notice: "{0}일 이후 Free 플랜으로 자동 전환됩니다.",

        cancel_plan_success: "플랜 취소가 완료되었습니다.",
        current_plan: "현재 플랜",
        credit: "크레딧",
        credit_addon: "크레딧(추가)",
        storage_addon: "스토리지(추가)",
        storage: "스토리지",
        next_billing_date: "다음 결제일: {0}",
        expired_billing_date: "만료일: {0}",
        payment_scheduled: "{0} 결제 예정",
        change_plan: "플랜 변경하기",
        buy_add_ons: "추가 옵션 구매",
        compare_plans: "플랜 비교하기",

        payment_method: "결제 방법",
        change: "변경",

        payment_history: "결제 내역",
        date: "날짜",
        item: "항목",
        amount: "금액",
        status: "상태",
        payment_details: "세부 정보",
        payment_method_col: "결제 수단",

        payment_complete: "결제 완료",
        download_invoice: "영수증",

        cancel_plan: "플랜 취소",
        cancel_subscription_undo: "구독 해지 취소",
        cancel_subscription_undo_confirm_title: "구독 해지 취소",
        cancel_subscription_undo_confirm_message: "정말로 구독 해지를 취소하시겠습니까?",
        cancel_subscription_undo_complete_title: "구독 해지 취소 완료",
        cancel_subscription_undo_complete_message: "구독 해지가 성공적으로 취소되었습니다.\n기존 혜택을 계속 이용하실 수 있습니다.",

        cancel_plan_modal_title: "플랜 취소",
        cancel_plan_desc_1: "{0}까지 이용",
        cancel_plan_desc_2: "{0}님, 지금 {1} 플랜 구독을 취소하셔도 {2}까지 계속 이용하실 수 있습니다. 그 이후에는 요금이 청구되지 않습니다.",

        plan_start_date: "플랜 시작: {0}",
        ai_optimization_count: "AI 최적화 실행",
        uploaded_file_size: "업로드한 파일 용량",
        avg_optimization_rate: "평균 최적화율",
        optimization_file_download: "최적화 파일 다운로드",

        cancel_reason_title: "취소하시는 이유는 무엇인가요?",
        cancel_plan_warning: "플랜을 취소하시면 2026년 1월 9일 이후 크레딧, 스토리지, 다운로드 기간 등이 Free 플랜 기준으로 초기화 됩니다. 정말 플랜을 취소하시겠습니까?",

        do_cancel: "취소하기",
        keep_plan: "유지하기",

        confirm: "확인",
        cancel: "취소",

        payment_method_change_title: "결제 수단 변경",
        payment_method_change_complete: "결제수단 변경이 완료되었습니다.",

        payment_success_title: "결제 완료",
        payment_success_message_new_plan: "결제가 성공적으로 완료되었습니다.\n새로운 플랜의 혜택을 지금 바로 이용해보세요.",
        payment_success_message_addon: "결제가 성공적으로 완료되었습니다.\n혜택을 지금 바로 이용해보세요.",

        use_free: "무료 사용하기",
        current_plan_badge: "현재 플랜",
        contact_us: "문의하기",

        error_title: "오류",
        error_server: "서버 통신 중 오류가 발생했습니다.",
        error_failed: "처리에 실패했습니다.",
        valid_until_format: "{0}까지",

        credit_usage_history: "크레딧 사용 내역",
        usage_context: "사용처",
        used_credit: "사용 크레딧",
        credit_type: "크레딧 타입",
        subscription_credit: "구독",
        addon_credit: "추가 구매",

        optimization_run_deduction: "최적화 실행 차감",
        optimization_failure_refund: "최적화 실패 환불",
        optimize_id: "최적화 ID",
    },
    ja: {
        coming_soon: "公開予定",
        payment_content: "決済内容",
        select_payment_method: "決済手段の選択",
        credit_card: "クレジットカード",
        kakaopay: "カカオペイ",
        transaction_id: "取引ID",
        payment_date: "決済日",
        quantity: "数量",
        subtotal: "小計",
        total: "合計",
        card_number: "カード番号",
        expiry_date: "有効期限",
        password_2digit: "パスワード(前2桁)",
        birth_date_6digit: "生年月日(6桁)",
        phone_number: "携帯電話番号",
        name: "名前",
        email: "メールアドレス",
        register_card: "決済する",
        addon_select_prompt: "追加購入するクレジットまたはストレージを選択してください",
        confirm_unsubscribe: "購読を解約しますか？",
        please_enter_name: "名前",
        please_enter_email: "メールアドレス",
        free_plan_conversion_notice: "{0}日後にFreeプランへ自動的に切り替わります。",

        cancel_plan_success: "プランのキャンセルが完了しました。",
        current_plan: "現在のプラン",
        credit: "クレジット",
        credit_addon: "クレジット(追加)",
        storage_addon: "ストレージ(追加)",
        storage: "ストレージ",
        next_billing_date: "次回決済日: {0}",
        expired_billing_date: "有効期限: {0}",
        payment_scheduled: "{0} 決済予定",
        change_plan: "プラン変更",
        buy_add_ons: "追加オプション購入",
        compare_plans: "プラン比較",

        payment_method: "決済方法",
        change: "変更",

        payment_history: "決済履歴",
        date: "日付",
        item: "項目",
        amount: "金額",
        status: "ステータス",
        payment_details: "詳細情報",
        payment_method_col: "決済手段",

        payment_complete: "決済完了",
        download_invoice: "領収書",

        cancel_plan: "プランキャンセル",
        cancel_subscription_undo: "購読解約の取り消し",
        cancel_subscription_undo_confirm_title: "購読解約の取り消し",
        cancel_subscription_undo_confirm_message: "本当に購読解約を取り消しますか？",
        cancel_subscription_undo_complete_title: "購読解約の取り消し完了",
        cancel_subscription_undo_complete_message: "購読解約が正常に取り消されました。\n既存の特典を引き続きご利用いただけます。",

        cancel_plan_modal_title: "プランキャンセル",
        cancel_plan_desc_1: "{0}まで利用可能",
        cancel_plan_desc_2: "{0}様、今{1}プランの購読をキャンセルしても{2}まで引き続きご利用いただけます。それ以降は料金が請求されません。",

        plan_start_date: "プラン開始: {0}",
        ai_optimization_count: "AI最適化実行",
        uploaded_file_size: "アップロードファイル容量",
        avg_optimization_rate: "平均最適化率",
        optimization_file_download: "最適化ファイルのダウンロード",

        cancel_reason_title: "キャンセルの理由は何ですか？",
        cancel_plan_warning: "プランをキャンセルすると2026年1月9日以降、クレジット、ストレージ、ダウンロード期間などがFreeプラン基準で初期化されます。本当にプランをキャンセルしますか？",

        do_cancel: "キャンセルする",
        keep_plan: "維持する",

        confirm: "確認",
        cancel: "キャンセル",

        payment_method_change_title: "決済手段の変更",
        payment_method_change_complete: "決済手段の変更が完了しました。",

        payment_success_title: "決済完了",
        payment_success_message_new_plan: "決済が正常に完了しました。\n新しいプランの特典を今すぐご利用ください。",
        payment_success_message_addon: "決済が正常に完了しました。\n特典を今すぐご利用ください。",

        use_free: "無料で使う",
        current_plan_badge: "現在のプラン",
        contact_us: "お問い合わせ",

        error_title: "エラー",
        error_server: "サーバー通信中にエラーが発生しました。",
        error_failed: "処理に失敗しました。",
        valid_until_format: "{0}まで",

        credit_usage_history: "クレジット使用履歴",
        usage_context: "使用先",
        used_credit: "使用クレジット",
        credit_type: "クレジットタイプ",
        subscription_credit: "プラン",
        addon_credit: "追加",

        optimization_run_deduction: "最適化実行差引",
        optimization_failure_refund: "最適化失敗返金",
        optimize_id: "最適化ID",
    },
};
